import React, { useEffect, useState } from 'react';
import { Slide1 } from './slides/Slide1';
import { Slide2 } from './slides/Slide2';
import { Slide3 } from './slides/Slide3';
import { Slide4 } from './slides/Slide4';
import { Slide5 } from './slides/Slide5';
import { Slide6 } from './slides/Slide6';
import { Slide7 } from './slides/Slide7';
import { Slide8 } from './slides/Slide8';
import { Slide9 } from './slides/Slide9';
import { Slide10 } from './slides/Slide10';
import { Slide11 } from './slides/Slide11';
import { Slide12 } from './slides/Slide12';
import { Slide13 } from './slides/Slide13';
export function App() {
  const [currentSlide, setCurrentSlide] = useState(1);
  const goToSlide = (slideNumber: number) => {
    if (slideNumber >= 1 && slideNumber <= 13) {
      setCurrentSlide(slideNumber);
    }
  };
  const nextSlide = () => goToSlide(currentSlide + 1);
  const prevSlide = () => goToSlide(currentSlide - 1);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight') {
        nextSlide();
      } else if (e.key === 'ArrowLeft') {
        prevSlide();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentSlide]);
  return <div className="w-screen h-screen overflow-auto flex p-8 bg-[#dbdbdb] pt-[5px] pb-[5px] pl-[5px] pr-[5px] flex-row items-center justify-center" data-id="element-0">
      <div className="w-full h-full max-w-[177.78vh] max-h-[56.25vw] bg-white relative rounded-2xl overflow-hidden" style={{
      transform: 'scale(0.95)',
      transformOrigin: 'center'
    }} data-id="element-1">
        {currentSlide === 1 && <Slide1 onNext={nextSlide} data-id="element-2" />}
        {currentSlide === 2 && <Slide2 onNavigate={goToSlide} onBack={prevSlide} data-id="element-3" />}
        {currentSlide === 4 && <Slide4 onNext={nextSlide} onBack={() => goToSlide(2)} data-id="element-4" />}
        {currentSlide === 5 && <Slide5 onNext={nextSlide} onBack={() => goToSlide(4)} data-id="element-5" />}
        {currentSlide === 6 && <Slide6 onBack={() => goToSlide(2)} data-id="element-6" />}
        {currentSlide === 7 && <Slide7 onNavigate={goToSlide} data-id="element-7" />}
        {currentSlide === 8 && <Slide8 onNavigate={goToSlide} data-id="element-8" />}
        {currentSlide === 9 && <Slide9 onNavigate={goToSlide} data-id="element-9" />}
        {currentSlide === 10 && <Slide10 onNavigate={goToSlide} data-id="element-10" />}
        {currentSlide === 11 && <Slide11 onNavigate={goToSlide} data-id="element-11" />}
        {currentSlide === 12 && <Slide12 onBack={() => goToSlide(2)} data-id="element-12" />}
        {currentSlide === 13 && <Slide13 onBack={() => goToSlide(2)} data-id="element-13" />}
      </div>
    </div>;
}